document.addEventListener('DOMContentLoaded', () => {
  const sucess = document.querySelector('.form-status__message--success');

  /**
   *
   */
  function formSuccess() {
    setTimeout(() => {
      window.location.href = '/pages/kontakt';
    }, 5000);
  }
  if (sucess) {
    formSuccess();
  }
});
